'use client'

import { StarIcon as StarIconOutline } from '@heroicons/react/24/outline'
import { StarIcon as StarIconSolid } from '@heroicons/react/24/solid'

export interface StarRatingProps {
  ratingOutOfFive: number
  color?: string
}

export const StarRating = (props: StarRatingProps) => {
  const { ratingOutOfFive, color } = props
  return (
    <div className="relative w-fit">
      <div className="flex w-fit gap-[2px]">
        {Array.from({ length: 5 }).map((_, i) => (
          <StarIconOutline key={i} className="size-[14px] text-bodi-gray-medium" />
        ))}
      </div>
      <div
        className="absolute inset-0 flex gap-[2px] overflow-hidden"
        style={{ width: `${ratingOutOfFive * 20}%` }}
      >
        {Array.from({ length: 5 }).map((_, i) => (
          <StarIconSolid key={i} className="size-[14px] shrink-0" style={{ color }} />
        ))}
      </div>
    </div>
  )
}
